import React, { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  extractDateFromStr,
  getLatestDateFromData,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import PdfZipItem from "../../components/PdfZipItem";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loader";

const SustainabilityPolicyReport = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: policyReportData = [], isLoading: noticeIsLoading } =
    useGetProtectedApiDataQuery({
      url: "sustainability_policy_report",
      lang: languageType,
    });
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  useTableResponsive(policyReportData);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(policyReportData);
  }, [policyReportData]);

  if (noticeIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Sustainable Development", "सतत विकास")}
        titleLink="/sustainable-development/sustainability-policy-report"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                <div className="mb-5">
                  <table className="table table-striped custom-table">
                    <thead>
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("Download", "डाउनलोड")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {policyReportData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Description", "विवरण")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Download", "डाउनलोड")}>
                            <PdfZipItem
                              filePath={item?.field_sustainability_policy_fil}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SustainabilityPolicyReport;
